export default "__VITE_ASSET__B907Xook__"